import * as types from "../../Action/type";

const initialState = {
    loading: false,
    activate:false,
}

const levelReducer = (state = initialState, action) => {
    switch (action.type) {
        
        case types.ACTIVATELEVEL:
            return {
                ...state,
                activate: action.payload,
                loading: false,
            };   
            
        default:
            return state;
    }
}

export default levelReducer;